// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TypesSourceBackup
 */
export interface TypesSourceBackup {
  /**
   *
   * @type {string}
   * @memberof TypesSourceBackup
   */
  backupName?: string;
  /**
   *
   * @type {string}
   * @memberof TypesSourceBackup
   */
  lastUpdatedTime?: string;
}

/**
 * Check if a given object implements the TypesSourceBackup interface.
 */
export function instanceOfTypesSourceBackup(
  value: object,
): value is TypesSourceBackup {
  return true;
}

export function TypesSourceBackupFromJSON(json: any): TypesSourceBackup {
  return TypesSourceBackupFromJSONTyped(json, false);
}

export function TypesSourceBackupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesSourceBackup {
  if (json == null) {
    return json;
  }
  return {
    backupName: json['BackupName'] == null ? undefined : json['BackupName'],
    lastUpdatedTime:
      json['LastUpdatedTime'] == null ? undefined : json['LastUpdatedTime'],
  };
}

export function TypesSourceBackupToJSON(json: any): TypesSourceBackup {
  return TypesSourceBackupToJSONTyped(json, false);
}

export function TypesSourceBackupToJSONTyped(
  value?: TypesSourceBackup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    BackupName: value['backupName'],
    LastUpdatedTime: value['lastUpdatedTime'],
  };
}
